import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

interface OriginCountryAddressTextField {
  key: string;
  labelKey: string;
  inputId: string;
  errorId: string;
  cssClass: string;
}

@Component({
  selector: 'app-partial-origin-country-address',
  templateUrl: './partial-origin-country-address.component.html',
  styleUrls: ['./partial-origin-country-address.component.scss'],
  standalone: false,
})
export class PartialOriginCountryAddressComponent {
  @Input() controls: { [key: string]: FormControl };

  public readonly firstRowMainFields: OriginCountryAddressTextField[] = [
    {
      key: 'originCountryAddressStreet',
      labelKey: 'ORIGIN-COUNTRY-ADDRESS-STREET',
      inputId: 'originCountryAddressStreetInput',
      errorId: 'originCountryAddressStreetError',
      cssClass: 'originCountryAddressStreet-field',
    },
    {
      key: 'originCountryAddressHouseNumber',
      labelKey: 'ORIGIN-COUNTRY-ADDRESS-HOUSE-NUMBER',
      inputId: 'originCountryAddressHouseNumberInput',
      errorId: 'originCountryAddressHouseNumberError',
      cssClass: 'originCountryAddressHouseNumber-field',
    },
  ];

  public readonly firstRowSideFields: OriginCountryAddressTextField[] = [
    {
      key: 'originCountryAddressApartmentNumber',
      labelKey: 'ORIGIN-COUNTRY-ADDRESS-APARTMENT-NUMBER',
      inputId: 'originCountryAddressApartmentNumberInput',
      errorId: 'originCountryAddressApartmentNumberError',
      cssClass: 'originCountryAddressApartmentNumber-field',
    },
  ];

  public readonly secondRowTextFields: OriginCountryAddressTextField[] = [
    {
      key: 'originCountryAddressPostalCode',
      labelKey: 'ORIGIN-COUNTRY-ADDRESS-POSTAL-CODE',
      inputId: 'originCountryAddressPostalCodeInput',
      errorId: 'originCountryAddressPostalCodeError',
      cssClass: 'originCountryAddressPostalCode-field',
    },
    {
      key: 'originCountryAddressCity',
      labelKey: 'ORIGIN-COUNTRY-ADDRESS-CITY',
      inputId: 'originCountryAddressCityInput',
      errorId: 'originCountryAddressCityError',
      cssClass: 'originCountryAddressCity-field',
    },
  ];
}
